import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Vehicule } from 'src/app/model/data-managemnt';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { DataManagementService } from '../../data-management/data-management.service';
import * as L from 'leaflet';
import Marker = L.Marker;
import Icon = L.Icon;
import { SigninService } from 'src/app/signin/signin.service';
import { DashboradComponent } from '../dashborad/dashborad.component';
import { ModalController, PopoverController } from '@ionic/angular';
import { PopupService } from './popup-rt.service';
import { InfoDeviceComponent } from './info-device/info-device.component';
import { StateService, ZoomState } from 'src/app/utils/leaflet/service/state.service';
import { Router } from "@angular/router";
import { VideoService } from "../video.service";
import { Path } from "../../../model/historical";

@Component({
  selector: 'app-popup-rt',
  templateUrl: './popup-rt.component.html',
  styleUrls: ['./popup-rt.component.scss'],
})
export class PopupRtComponent implements OnInit {
  vehicule: Vehicule;
  translations: any;
  langChanged: boolean;
  date: Date;
  signal: number;
  kilometrage: number;
  etat: any;
  isHidden: boolean = true;

  constructor(
    public dataManagementService: DataManagementService,
    private modalController: ModalController,
    public signinService: SigninService,
    private stateservice: StateService,
    public videoService: VideoService,
    public translate: TranslateService,
    private router: Router,
    private mapService: MapService,
    private popupService: PopupService,
    private popoverCtrl: PopoverController) {

  }
  ngOnInit() { }

  loadVehicule(vehicule: Vehicule, etat: any, translations: any, marker: any, isDetails: boolean) {
    this.vehicule = vehicule;
    this.date = new Date(vehicule.realTimeRecord.recordTime);
    this.signal = Math.round((Number(vehicule.realTimeRecord.signal) / 32 * 100))
    this.kilometrage = Math.round(vehicule.odo)
    this.etat = etat
    this.translations = translations
    this.popupService.marker = marker;
    this.isHidden = !isDetails;
  }

  formatDate(date: any) {
    const value = this.vehicule?.realTimeRecord?.recordTime ?? date;
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) {
      return '';
    }
    let minutes = d.getMinutes() + '';
    if (minutes.length === 1) {
      minutes = '0' + d.getMinutes();
    }
    let month: number | string = d.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = d.getDate() + '';
    if (day.length === 1) {
      day = '0' + d.getDate();
    }
    let hour = d.getHours() + '';
    if (hour.length === 1) {
      hour = '0' + d.getHours();
    }
    return day + '/' + month + '/' + d.getFullYear() + ' ' + hour + ':' + minutes;
  }

  voirHistorique() {
    console.log("historique :" ,
      this.vehicule.matricule
    )
    this.dataManagementService.selectedVehicule=this.vehicule;
    console.log("selected :" ,
      this.dataManagementService.selectedVehicule.matricule
    )
    this.popupService.voirHistorique()
  }

  displayTodaysMileage(vehicule: Vehicule) {
    let lat = this.popupService.getVehicule(this.vehicule.idDevice)[0].realTimeRecord.coordinate.lat
    let lng = this.popupService.getVehicule(this.vehicule.idDevice)[0].realTimeRecord.coordinate.lng
    //this.stateservice.setSelectedMarker(stop);
    this.stateservice.setSelectedMarkerWith2Parm(lat, lng);
    this.stateservice.updateState(ZoomState.DisplayPath);
    this.popupService.displayTodaysMileage(vehicule)
  }

  arreterDemarrer(ev: any, vehicule: any) {
    this.popupService.arreterDemarrer(ev, vehicule)
  }

  async openDashborad() {
    const modalDash = await this.popoverCtrl.create({
      component: DashboradComponent,
      cssClass: 'vehicle-dashboard-modal',
      showBackdrop: true,
      backdropDismiss: true,
      animated: true,
      mode: 'md',
      keyboardClose: true,
      alignment: "center"
    });


    return await modalDash.present();
  }


  displayCurrentPath(deviceId: number) {
    if (this.popupService.getVehicule(this.vehicule.idDevice)[0].realTimeRecord.ignition == true) {
      this.popupService.displayCurrentPath(deviceId);
      let lat = this.popupService.getVehicule(this.vehicule.idDevice)[0].realTimeRecord.coordinate.lat
      let lng = this.popupService.getVehicule(this.vehicule.idDevice)[0].realTimeRecord.coordinate.lng
      this.mapService.centerMapMarker(lat, lng);
    }

  }


  initTimerCurrentPath() {
 this.stateservice.updateState(ZoomState.currentpath)
    clearTimeout(this.popupService.liveReloadingRT);
    let idDevice = this.popupService.getVehicule(this.vehicule.idDevice)[0].idDevice
    this.displayCurrentPath(idDevice);
    // this.popupService.liveReloadingRT = setInterval(() => {
    //   if (this.popupService.hideCurrentPath == false) {
    //     this.displayCurrentPath(idDevice);
    //   }
    // }, 20000);

  }

  drawpath() {
    this.popupService.drawpath(this.vehicule, this.popupService.currentlocationlat, this.popupService.currentlocationlng)
  }

  currentPosition() {
    this.popupService.currentPosition(this.vehicule, this.popupService.currentlocationlat, this.popupService.currentlocationlng)
  }

  async openInfoDevice(ev: any, vehic: any) {
    let vehicule = vehic.idDevice;
    let group = this.dataManagementService.selectedGroup;
    let selectedV = { "group": group, "vehicule": vehicule };

    let popover = await this.popoverCtrl.create({
      component: InfoDeviceComponent,
      event: ev,
      translucent: false,
      cssClass: 'details'
    });
    return await popover.present();
  }
  openCamPage() {
    if (this.videoService.counter === 0)
      this.videoService.onConnectClick(this.dataManagementService.selectedVehicule)
    this.videoService.type = "stream"
    this.router.navigate(['camera']);
  }

/*
  systemTime = new Date().getTime();
  time: number;
  updateTime: number;
  etatVehicule: string = '';
  color: string = '';
  icon: string = '';
  hoverValue : string ='';
  EtatVehicule(vehicule: Vehicule) {
    if (vehicule.realTimeRecord.realTimeRecordStatus === 'VALID') {
      switch (vehicule.etat) {
        case 'red':
          this.icon = 'circle';
          this.color = 'red';
          this.etatVehicule = this.translations.REALTIME.stopped;
          break;
        case 'green':
          this.icon = 'circle';
          this.color = 'green';
          this.etatVehicule = this.translations.REALTIME.working;
          break;
        case 'blue':
          this.icon = 'circle';
          this.color = 'blue';
          this.etatVehicule = this.translations.REALTIME.temporarystop;
          break;
      }
    }
   
    else if (vehicule.realTimeRecord.realTimeRecordStatus === 'TECHNICAL_ISSUE' || vehicule.realTimeRecord.realTimeRecordStatus === 'NON_VALID') {
      this.time = vehicule.realTimeRecord.recordTime;
      this.updateTime = vehicule.realTimeRecord.lastRawTime;
      // Calcul des différences de temps en heures
      const timeDifference1 = (this.systemTime - this.time) / (1000 * 60 * 60);
      const timeDifference2 = (this.systemTime - this.updateTime) / (1000 * 60 * 60);

      if (timeDifference1 > 12 || timeDifference2 > 12) {
        switch (vehicule.etat) {
          case 'gray':
            this.icon = 'exclamation-triangle';
            this.etatVehicule = this.translations.REALTIME.pasdesignalGPS;
            break;
          case 'panne':
            this.icon = 'exclamation-circle';
            this.etatVehicule = this.translations.REALTIME.panne;
            break;
        }
      } else {
        switch (vehicule.etat) {
          case 'gray':
            this.icon = 'exclamation-triangle';
            this.etatVehicule = this.translations.REALTIME.Valdie +' '+"pasdesignalGPS";
            this.color = 'rouge';
            break;
          case 'panne':
            this.icon = 'exclamation-triangle';
            this.etatVehicule = this.translations.REALTIME.nonConnecté;
            this.color = 'rouge';
            break;
        }
     
      }
    }
    else {
      this.etatVehicule = this.translations.REALTIME.Étatnonmentionné;

    }
    return {
      etatVehicule: this.etatVehicule,
      icon: this.icon,
      color: this.color
    };
  }


*/



}
